import Color from 'color';

// Generic
const black = Color('#000');
const white = Color('#fff');
const dark = Color('#010101');
const light = Color('#fafafa');

// Alerts
const alertsAmber = Color('#ff7f00');
const alertsRed = Color('#d2000a');
const alertsGreen = Color('#005a2b');

// Active, Focus
const activeBlue = Color('#4a90e2');
const activeGreen = Color('#009B39');

// Disabled
const disabledGrey = Color('#e4e4e4');

// Hover
const tabsHover = Color('#a8aaae');

// Warning text color
const warningText = Color('#a55200');

const foreground = Color('#202020');
const background = Color('#fcfae8');
const link = Color('#2020e0');
const ring = Color('#4a90e2');
const disabledCta = Color('#85888D');

const colors = {
	black,
	white,
	alertsAmber,
	alertsRed,
	alertsGreen,
	activeBlue,
	activeGreen,
	disabledGrey,
	tabsHover,
	warningText,
	foreground,
	background,
	link,
	dark,
	light,
	ring,
	disabledCta,
};

export default colors;
